import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export function LiveClock({ compact = false }) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  };

  if (compact) {
    return (
      <div 
        className="flex items-center gap-2"
        data-testid="live-clock"
      >
        <Clock className="w-3.5 h-3.5" style={{ color: 'var(--primary)' }} />
        <span 
          className="text-sm font-bold tabular-nums"
          style={{ 
            fontFamily: 'Teko, sans-serif',
            color: 'var(--text-main)',
            letterSpacing: '0.05em'
          }}
        >
          {formatTime(time)}
        </span>
      </div>
    );
  }

  return (
    <div 
      className="flex items-center justify-between p-3"
      style={{ backgroundColor: 'var(--surface-highlight)' }}
      data-testid="live-clock"
    >
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4" style={{ color: 'var(--primary)' }} />
        <span 
          className="text-xs font-medium"
          style={{ color: 'var(--text-muted)' }}
        >
          {formatDate(time)}
        </span>
      </div>
      <span 
        className="text-lg font-bold tabular-nums"
        style={{ 
          fontFamily: 'Teko, sans-serif',
          color: 'var(--text-main)',
          letterSpacing: '0.05em'
        }}
      >
        {formatTime(time)}
      </span>
    </div>
  );
}
